import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import AboutHero from './components/AboutHero';
import AboutCompany from './components/AboutCompany';
import Mission from './components/Mission';
import Vision from './components/Vision';
import Values from './components/Values';
import Team from './components/Team';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <AboutHero />
      <AboutCompany />
      <Mission />
      <Vision />
      <Values />
      <Team />
      <Footer />
    </div>
  );
}
